<!--
 * @Author: zhouhx
 * @Date: 2022-03-07 15:10:14
 * @LastEditors: zhouhx
 * @LastEditTime: 2024-03-04 09:55:07
 * @Description: 详情-基础信息
-->
<template>
  <div class="case-consult-info">
    <van-collapse v-model="activeNames" class="casedetailNav">
      <van-collapse-item name="1" class="casedetailNavTop">
        <template #title>
          <div>
            <span class="name">{{ baseInfo.patientName }}</span>
            <span class="sexAge">{{ baseInfo.patientGender }}，{{ baseInfo.patientAge }}</span>
          </div>
          <div class="navRight" v-if="from === 'referral'">
            <span class="right" :class="{
              'nodone': baseInfo.referralStatus === 1 || baseInfo.referralStatus === 2 || baseInfo.referralStatus === 3,
              'needdone': baseInfo.referralStatus === 4 || baseInfo.referralStatus === 7,
              'hasdone': baseInfo.referralStatus === 6
            }">{{
  baseInfo.caseStatusString
}}</span>
          </div>
          <div class="navRight" v-else>
            <span class="left" v-if="baseInfo.businessCaseMode === 2">急</span>
            <span class="right" :class="{
              'nodone': baseInfo.caseStatus === 0 || baseInfo.caseStatus === 2 || baseInfo.caseStatus === 12,
              'needdone': baseInfo.caseStatus === 1 || baseInfo.caseStatus === 3,
              'hasdone': baseInfo.caseStatus === 4 || baseInfo.caseStatus === 5
            }">{{
  baseInfo.caseStatusString
}}</span>
          </div>
        </template>
        <div class="navBottomSteps">
          <casepPocess :data="stepData" :active="currentStatus"></casepPocess>
        </div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>
<script>
import casepPocess from '@/components/basics/case-process';
export default {
  components: { casepPocess },
  props: {
    edit: {},
    baseInfo: {},
    from: {}
  },
  watch: {
    // 监听是否展开
    activeNames: function (newVal) {
      if (newVal.length === 1 && !this.hiddenContent) {
        if (this.from !== 'referral') {
          this.cloudSteps();
        } else {
          this.referralSteps();
        }
        this.hiddenContent = true;
      }
    }
  },
  data () {
    return {
      hiddenContent: false,
      stepData: [],
      currentStatus: 0,
      activeNames: []
    }
  },
  methods: {
    // 获取步骤条
    cloudSteps () {
      this.$axios
        .post('case/status/list', {
          version: this.$version,
          data: { caseId: this.baseInfo.id }
        })
        .then((res) => {
          if (res.status) {
            res.data.operatorList.forEach((element, index) => {
              if (element.statusEnum === res.data.nowStatus) {
                this.currentStatus = index;
              }
              this.stepData.push({
                title: element.statusEnum
              });
            });
          }
        });
    },
    referralSteps () {
      this.$axios
        .post('api/dual/referral/status/list', {
          version: this.$version,
          data: { referralId: Number(this.$route.query.dataid) }
        })
        .then((res) => {
          if (res.status) {
            res.data.forEach((element, index) => {
              if (element.statusText === this.baseInfo.caseStatusString) {
                this.currentStatus = index;
              }
              this.stepData.push({
                title: element.statusText
              });
            });
          }
        });
    }
  }
}
</script>
<style lang="scss" scoped>
.casedetailNav {
  .name {
    font-size: 16px;
    color: $black;
    font-weight: 700;
    margin-right: 29px;
  }

  .sexAge {
    margin-right: 14px;
    font-size: 14px;
    color: $black;
  }

  .navRight {
    position: absolute;
    right: 26px;
    top: 50%;
    transform: translateY(-50%);

    .left {
      display: inline-block;
      width: 24px;
      height: 24px;
      line-height: 23px;
      text-align: center;
      border: 1px solid $red;
      border-radius: 50%;
      font-size: 12px;
      color: $red;
      margin-right: 24px;
    }

    .right {
      font-size: 10px;
      padding: 5px 8px;
    }

    .nodone {
      background: $slightgrey;
      color: $grey;
    }

    .needdone {
      background: $sligtblue;
      color: $blue;
    }

    .hasdone {
      background: $sligtgreen;
      color: $green;
    }
  }

  .navBottomCont {
    font-size: 14px;
    color: $black;
    margin-top: 8px;
  }

  .navBottomSteps {
    width: 100%;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
